import { render, staticRenderFns } from "./AdminBoardsV2Rollout.vue?vue&type=template&id=cbef8cee&scoped=true"
import script from "./AdminBoardsV2Rollout.vue?vue&type=script&lang=ts"
export * from "./AdminBoardsV2Rollout.vue?vue&type=script&lang=ts"
import style0 from "./AdminBoardsV2Rollout.vue?vue&type=style&index=0&id=cbef8cee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbef8cee",
  null
  
)

export default component.exports